import Input from '../InputText/InputTextComponent';
import FormElement from '../FormElement';

export default function InputEditComponent({ value, onChange, label, desc, type }) {
    const onKeyDown = (e) => {
        if (type === 'number') {
            if (!/[0-9]/.test(e.key)) {
                e.preventDefault();
            }
        }
        if (['jsPath', 'number'].includes(type)) {
            if (e.keyCode === 32) {
                e.preventDefault();
            }
        }
    };
    return (
        <FormElement label={label} desc={desc}>
            <Input variant='normal-padding' value={value || ''} setValue={onChange} onKeyDown={onKeyDown}></Input>
        </FormElement>
    );
}
